import { lazy } from 'react'
import { NVButton } from '@nv/basic-components'
import { useNVModal } from '@nv/components'
import DownloadFileIcon from '@nv/images/design/download-file-icon'
import { AdminVoterService } from '@nv/services'
import { useTranslation } from 'react-i18next'
import styles from './AdminElectionConfig.module.scss'
const SuccessDownloaded = lazy(() => import('@nv/lazy-loadable/lib/modals/SuccessDownloaded'))
const Downloading = lazy(() => import('@nv/lazy-loadable/lib/modals/Downloading'))

// TODO: revisit this page, right now it's very specific to PEI

export const AdminElectionConfig = () => {
  const { t } = useTranslation()
  const { NVModal: SuccessDownloadedModal, openModal: openSuccessDownloadedModal } = useNVModal()
  const { NVModal: DownloadingModal, openModal: openDownloadingModal, closeModal: closeDownloadingModal } = useNVModal()

  const getDowloadUrlVoters = async (districts) => {
    openDownloadingModal()
    const res = await AdminVoterService.fetchEventConfigVotersBySchoolBoard(districts)
    if (res?.success) {
      // @ts-ignore
      const href = URL.createObjectURL(res.data)
      const link = document.createElement('a')
      link.download = `${districts}-voterlist`
      link.href = href
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      closeDownloadingModal()
      openSuccessDownloadedModal()
    }
  }
  const getDowloadUrlJurisdictions = async (districts) => {
    openDownloadingModal()
    const res = await AdminVoterService.fetchEventConfigJurisdictionsBySchoolBoard(districts)
    if (res?.success) {
      // @ts-ignore
      const href = URL.createObjectURL(res.data)
      const link = document.createElement('a')
      link.download = `${districts}-jurisdictions`
      link.href = href
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      closeDownloadingModal()
      openSuccessDownloadedModal()
    }
  }

  return (
    <>
      <DownloadingModal>
        <Downloading />
      </DownloadingModal>

      <SuccessDownloadedModal>
        <SuccessDownloaded />
      </SuccessDownloadedModal>

      <div className={styles['container-outer']}>
        <div className={styles['container']}>
          <div className={styles['body']}>
            <span className={styles['body__txt']}>PSB</span>
          </div>
          <div className={styles['footer']}>
            <div style={{ display: 'flex' }}>
              {t('admin.electionConfig.jurisdictions')}
              <NVButton
                variant='iconOnly'
                icon={<DownloadFileIcon />}
                onClick={() => getDowloadUrlJurisdictions('PSB')}
                ariaLabel={t('buttons.download')}
              />
            </div>
            <div style={{ display: 'flex' }}>
              {t('admin.electionConfig.electors')}
              <NVButton
                variant='iconOnly'
                icon={<DownloadFileIcon />}
                onClick={() => getDowloadUrlVoters('PSB')}
                ariaLabel={t('buttons.download')}
              />
            </div>
          </div>
        </div>
        <div className={styles['container']}>
          <div className={styles['body']}>
            <span className={styles['body__txt']}>CSLF</span>
          </div>
          <div className={styles['footer']}>
            <div style={{ display: 'flex' }}>
              {t('admin.electionConfig.jurisdictions')}
              <NVButton
                variant='iconOnly'
                icon={<DownloadFileIcon />}
                onClick={() => getDowloadUrlJurisdictions('CSLF')}
                ariaLabel={t('buttons.download')}
              />
            </div>
            <div style={{ display: 'flex' }}>
              {t('admin.electionConfig.electors')}
              <NVButton
                variant='iconOnly'
                icon={<DownloadFileIcon />}
                onClick={() => getDowloadUrlVoters('CSLF')}
                ariaLabel={t('buttons.download')}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
